import React, { useState, useEffect, useRef  }  from "react";

import "../styles/SmartVending.css";
import Footer from '../component/footer';

const cdnURL = process.env.REACT_APP_CDN_URL;

const SmartVending = () => { 

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    
    const handleResize = () => {
        setScreenWidth(window.innerWidth);
    };
        
    useEffect(() => {
        window.removeEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    });

     return (
        <div className="smartvending_page">

            <div className="back_video">
            
                <div className="overlay">
                    <div className="top_section">
                        <img src={`${cdnURL}/logo/logo_spaceX_selected.svg`} />
                        <h1> Vending Machine</h1>
                    </div>
                    <div className="sec-section">
                        <h2>CONVENIENCE WITHOUT COMPROMISE</h2>
                    </div>
                    <div className="third-section">
                        <p>Integrating cashless solutions with retail expertise, our smart vending machines offer a brand-new experience {screenWidth > 600 ? <br/>: null}for convenience shoppers. Stepping outside for a quick purchase has never been more convenient.</p>
                    </div>
                    <div className="btn-section">
                        <a href={`https://www.spacedx.com.my/`} target="_blank" rel="noopener noreferrer" className="btn learn-btn" style={{ "--arrow-icon": `url(${cdnURL}/icon/icon_red_arrow.svg)` }}><span>Learn More</span></a>
                    </div>
                </div>

                <div className="video-section"> 
                    <video  className="background-video" autoPlay loop muted playsInline >
                        <source src={`${cdnURL}/video/smartvendingmachine.mp4`} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            
            </div>

            <div style={{padding:"60px 100px 0px 100px", backgroundColor:'#F5F4F5'}}>
                <Footer/>
            </div>
        </div>
     );
};

export default SmartVending;